import { OperationalReportTypeUpsertModelStore } from './operational-report-type-upsert-model.store';
import { fb, routeParams } from '../../../../../shared/shared.global-service';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TextInputComponent } from '../../../../../../components/kit/input/text-input/text-input.component';
import { Validators } from '@angular/forms';
import { BaseDialogComponent } from '../../../../../../components/kit/base-dialog/base-dialog.component';
import { isInvalid } from '../../../../../shared/helpers/validate';
import { contentGlobalSuccess } from '../../../../content.error';

@Component({
    selector: 'app-operational-report-type-upsert-model',
    templateUrl: './operational-report-type-upsert-model.component.html',
    styleUrl: './operational-report-type-upsert-model.component.scss',
    providers: [OperationalReportTypeUpsertModelStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TextInputComponent,
    ],
})
export class OperationalReportTypeUpsertModelComponent extends BaseDialogComponent {

    public readonly store = inject(OperationalReportTypeUpsertModelStore);

    protected form = fb.group({
        id: fb.control<number | null>(null),
        key: fb.control<string | null>(null, Validators.required),
    });

    constructor() {
        super();
        const type = this.dialogConfig.data.type;
        this.form.patchValue({
            id: type?.id || null,
            key: type?.key || null,
        });
    }

    public override async save(_event: Event): Promise<void> {
        if (isInvalid(this.form)) return;

        if (this.form.value.id) {
            await this.store.api.patchOperationalReportType({
                id: this.form.value.id!,
                key: this.form.value.key!,
            }, 'ok');
            contentGlobalSuccess.next('common.updated');
        } else {
            await this.store.api.createOperationalReportType({
                key: this.form.value.key!,
                serviceId: Number(routeParams.serviceId()),
            }, 'id');
            contentGlobalSuccess.next('common.created');
        }

        this.dialogRef.close(true);
    }

}
